import { useEffect, useRef, useState } from "react";

const OverLay = ({ clicked, breakPoint }) => {
  const overlayRef = useRef();

  const [windowWidth, setWindowWidth] = useState(0);

  useEffect(() => {
    const updateWindowWidth = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", updateWindowWidth);

    return () => window.removeEventListener("resize", updateWindowWidth);
  }, []);

  useEffect(() => {
    if (windowWidth >= breakPoint) {
      overlayRef.current.click();
    }
  }, [windowWidth, breakPoint]);

  return (
    <div
      className="fixed top-0 left-0 w-full h-screen bg-black opacity-20 z-30"
      onClick={clicked}
      ref={overlayRef}
    />
  );
};

export default OverLay;
